// extracted by mini-css-extract-plugin
module.exports = {"comp":"BannerA_comp__O9r2N","banner-tips-icon":"BannerA_banner-tips-icon__DCfOP"};